import { FileType } from '../../../features/MediaAssets/Details/FileUpload';
import { WorkflowElement } from '../../models/template';
import { columnType } from './DynamicRowsComponent';

interface FileUploadInterface {
  fileId: string;
  id: string;
  url: string;
  fileName: string;
}

export interface ComponentsPropsI {
  elementDetails: WorkflowElement;
  disabled: boolean;
  saveDynamicTableData?: (
    data: any,
    validationData: any,
    removed: any,
    added: any,
    // alterHistory: string,
    initialElementValue: any,
    headers: columnType[],
  ) => void;
  onChangeHandler: any;
  classNameFunc?: (defaultValue: boolean, name: string) => string;
  errorMessage?: {
    [key: string]: string;
  };
  masterOptions?: {
    key: string;
    text: string;
    value: string;
  }[];
  usersOptions?: {
    key: string;
    text: string;
    value: string;
  }[];
  index: number;
  onPhotoClick: () => void;
  unfocusHandler?: () => void;
  mastersHandler?: any;
  usersHandler?: any;
  templateId?: string;
  getUploadedFiles: (uploadedFiles: FileType, index: number) => void;
  camImage?: FileUploadInterface[];
  addPhotographsHandler?: () => void;
  subTaskIdNo?: string;
  subTaskName?:string;
  RoleChecker?: boolean;
  // formName?: string;
  onConfirmUser: any;
  mode?: number;
  DepartmentOptions?: {
    key: string;
    text: string;
    value: string;
  }[];
  DepartmentHandler?: any;
  linkColumnName?: string;
  linkColumnValue?: string;
  name?:string;
  allElementsData?: any[];
}

export const  isInvalidFrame = (value: any): boolean => {
  // Return true if the value is a string containing only alphabetic characters, or not a number
  if (typeof value === 'string' && /^[a-zA-Z]+$/.test(value)) {
    return true;  // It's an invalid string (alphabets)
  }
  

  return isNaN(Number(value));  // Return true if it's NaN, false otherwise
}

